import React from "react";
import "./preview-full.css";

const PreviewFull = ({ content, experience, projects, skills, darkMode }) => {
    return (
        <div className={`preview-full-site ${darkMode ? "dark" : "light"}`}>
            {/* Hero Section */}
            <section className="preview-hero-full">
                <div className="preview-hero-container">
                    <h1 className="preview-hero-title">{content.name || "Your Name"}</h1>
                    <p className="preview-hero-subtitle">{content.title || "Your Title"}</p>
                    <p className="preview-hero-desc">{content.description || "Your description"}</p>
                    {content.tags && content.tags.length > 0 && (
                        <div className="preview-hero-tags">
                            {content.tags.map((tag, idx) => (
                                <span key={idx} className="preview-tag-badge">{tag}</span>
                            ))}
                        </div>
                    )}
                </div>
            </section>

            {/* About Section */}
            {content.about_paragraphs && content.about_paragraphs.length > 0 && (
                <section className="preview-section-full-site">
                    <div className="preview-section-container">
                        <h2 className="preview-section-title">
                            <span className="emoji">📖</span> About Me
                        </h2>
                        {content.about_title && <h3 className="preview-subtitle-large">{content.about_title}</h3>}
                        {content.about_subtitle && <p className="preview-intro-text">{content.about_subtitle}</p>}
                        <div className="preview-paragraphs">
                            {content.about_paragraphs.map((para, idx) => (
                                <p key={idx} className="preview-paragraph">{para}</p>
                            ))}
                        </div>
                    </div>
                </section>
            )}

            {/* Experience Section */}
            {experience && experience.length > 0 && (
                <section className="preview-section-full-site">
                    <div className="preview-section-container">
                        <h2 className="preview-section-title">
                            <span className="emoji">💼</span> Experience
                        </h2>
                        <div className="preview-exp-timeline">
                            {experience.map((exp, idx) => (
                                <div key={idx} className="preview-exp-card">
                                    <div className="preview-exp-header">
                                        <h3 className="preview-exp-company">{exp.company}</h3>
                                        <span className="preview-exp-role">{exp.role}</span>
                                    </div>
                                    <p className="preview-exp-duration">{exp.duration}</p>
                                    <p className="preview-exp-description">{exp.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            )}

            {/* Projects Section */}
            {projects && projects.filter(p => p.visible !== false).length > 0 && (
                <section className="preview-section-full-site">
                    <div className="preview-section-container">
                        <h2 className="preview-section-title">
                            <span className="emoji">🎮</span> Projects
                        </h2>
                        <div className="preview-projects-grid">
                            {projects.filter(p => p.visible !== false).map((project) => (
                                <div key={project.id} className="preview-project-card">
                                    {project.img && (
                                        <div className="preview-project-img">
                                            <img src={project.img} alt={project.title} onError={(e) => e.target.style.display = 'none'} />
                                        </div>
                                    )}
                                    <div className="preview-project-content">
                                        <h4 className="preview-project-title">{project.title}</h4>
                                        <p className="preview-project-desc">{project.description}</p>
                                        {project.link && (
                                            <a href={project.link} target="_blank" rel="noopener noreferrer" className="preview-project-link">
                                                View Project →
                                            </a>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            )}

            {/* Skills Section */}
            {skills && skills.filter(s => s.visible !== false).length > 0 && (
                <section className="preview-section-full-site">
                    <div className="preview-section-container">
                        <h2 className="preview-section-title">
                            <span className="emoji">⚡</span> Skills
                        </h2>
                        <div className="preview-skills-categories">
                            {["core", "ui", "platform", "advanced", "tools"].map((category) => {
                                const categorySkills = skills.filter(s => s.category === category && s.visible !== false);
                                if (categorySkills.length === 0) return null;
                                return (
                                    <div key={category} className="preview-skill-category">
                                        <h4 className="preview-skill-category-title">
                                            {category.charAt(0).toUpperCase() + category.slice(1)}
                                        </h4>
                                        <div className="preview-skill-tags">
                                            {categorySkills.map((skill, idx) => (
                                                <span key={idx} className="preview-skill-tag">{skill.name}</span>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </section>
            )}

            {/* Contact Section */}
            {content.socials && content.socials.length > 0 && (
                <section className="preview-section-full-site preview-contact-full">
                    <div className="preview-section-container">
                        <h2 className="preview-section-title">
                            <span className="emoji">📬</span> Get In Touch
                        </h2>
                        {content.contact_title && <h3 className="preview-subtitle-large">{content.contact_title}</h3>}
                        {content.contact_subtitle && <p className="preview-intro-text">{content.contact_subtitle}</p>}
                        <div className="preview-socials-links">
                            {content.socials.map((social, idx) => (
                                <a 
                                    key={idx} 
                                    href={social.url} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="preview-social-btn"
                                >
                                    <i className={social.icon}></i>
                                    <span>{social.name}</span>
                                </a>
                            ))}
                        </div>
                    </div>
                </section>
            )}

            {/* Footer */}
            <footer className="preview-footer-full">
                <p>&copy; 2025 {content.name || "Your Name"}. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default PreviewFull;
